module.exports = __webpack_public_path__ + "static/media/elektroforeza.cfe25cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/elektroforeza.jpg
// module id = 416
// module chunks = 0